<template>
    <b-modal ref="modal" size="lg" centered :title="$t('WORKINGGROUPCHILDFORM')" @close="close()" no-close-on-backdrop
        no-close-on-esc hide-footer>
        <div class="d-block mt-2">
            <div role="group" class="b-form-group form-group" v-if="formData != null">
                <div class="row mb-2">
                    <div class="col-12">
                        <button type="button" class="btn btn-primary button-add pull-right"
                        @click="exportCsv()">{{ $t('EXPORTCHILDREN') }}</button>
                    </div>
                </div>
                <div class="form-row mb-lg">
                    <div class="col-sm-12 table-responsive">
                        <table class="table table-bordered table-striped table-hover table-sm table-logoped">
                            <thead>
                                <tr>
                                    <th>
                                        {{ $t('ORDERNUM') }}
                                    </th>
                                    <th>
                                        {{ $t('NAME') }}
                                    </th>
                                    <th>{{ $t('ACTION') }}</th>
                                </tr>
                            </thead>
                            <draggable v-model="response.root" @start="drag = true" @end="drag = false"
                                @change="changeOrder" tag="tbody">
                                <tr v-for="(item, index) in response.root" :key="item.childId" aria-rowindex="1"
                                    class=" table-ellipsis" :style="getStyle(item, index)">
                                    <td>{{ ( ((pagination.currentPage - 1) * pagination.limit) + index + 1) }}</td>
                                    <td>{{ item.fullname }}</td>
                                    <td><c-switch
                                        type="text"
                                        variant="primary-outline-alt"
                                        v-bind:on="$t('ON')"
                                        v-bind:off="$t('OFF')" :pill="true"
                                        :checked="switchStates.find(s => s.id === item.childId).checked"
                                        v-on:change="submitData(item)"
                                        :key="`switch-${item.notificationId}-${item.workingGroupId}`"
                                    />
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                        <nav>
                            <pagination v-bind:totalCount="response.totalCount" v-model="pagination" v-on:reload="getData">
                            </pagination>
                        </nav>
                    </div>
                </div>
            </div>

            <div class="text-right">
                <b-btn class="mr-2 button-cancel" @click="close()">{{ $t('CLOSE') }}</b-btn>
            </div>
        </div>
    </b-modal>
</template>


<script>
import {
    mapGetters,
}
    from 'vuex';
import cSwitch from '../../components/lib/Switch'
import Api from '@/api/working_group/WorkingGroup';

export default
    {
        name: 'WorkingGroupForm',
        props: ['value'],
        components: {
            cSwitch
        },
        data() {
            const me = this;

            return {
                columns: [
                    {
                        key: 'fullname',
                        name: me.$t('NAME'),
                    },
                    {
                        id: 'actions',
                        name: me.$t('ACTIONS'),
                    },
                ],
                formError: {},
                formData: null,
                response:
                    {},
                pagination:
                {
                    query: '',
                    currentPage: 1,
                    limit: 25,
                    searchTimeout: false,
                    companyId: '',
                    initialId: null,
                    sort: null,
                    readingType: null,
                },
            };
        },
        methods:
        {
            async exportCsv()
            {
                const me = this;
                try
                {
                    const params = me.getParams;
                    params.limit = 10000000;
                    params.numberOfChildren = me.formData.numberOfChildren;
                    const data = await Api.exportData(params);
                    // if (data.error && data.error === true) {
                    //     throw (data);
                    // }

                    // let i = 0;
                    // const childrenInGroup = [];
                    // for (const child of data.root)
                    // {
                    //     if (child.workingGroupId != null && i < me.formData.numberOfChildren)
                    //     {
                    //         childrenInGroup.push({
                    //             fullname: child.fullname,
                    //             phoneNumber: child.phoneNumber,
                    //             allergies: child.allergies
                    //         });
                    //     }
                    // }

                    // const header = [me.$t('NAME'), me.$t('PHONENUMBER'), me.$t('ALLERGIES')];
                    // let csvContent = "data:text/csv;charset=utf-8,";


                    // const gridData = childrenInGroup.map(item => Object.values(item).join(";").replaceAll("\n", ", "));

                    // csvContent += [
                    //     header.join(";"),
                    //     ...gridData
                    // ]
                    //     .join("\n")
                    //     .replace(/(^\[)|(\]$)/gm, "");

                    // const csvData = encodeURI(csvContent);
                    // const link = document.createElement("a");
                    // link.setAttribute("href", csvData);
                    // link.setAttribute("download", "export.csv");
                    // link.click();
                }
                catch (error)
                {
                    console.log(error);
                    me.$notify.notice(error);
                }

            },
            getStyle(item, index) {
                const me = this;
                const style = {}

                if (item.workingGroupId != null)
                {
                    if (index < me.formData.numberOfChildren)
                    {
                        style.backgroundColor = '#87ff87';
                    }
                    else
                    {
                        style.backgroundColor = '#FFA500';
                    }
                }

                return style;
            },
            async changeOrder(item) {
                var me = this;
                try {
                    var moved = item.moved;

                    var movedData = moved.element;
                    var oldData = me.response.root[moved.newIndex + 1];

                    var finalNum = parseInt(oldData.orderNum) - 1;

                    var data = await Api.updateOrderNumber(
                        {
                            childId: movedData.childId,
                            workingGroupId: me.formData.workingGroupId,
                            finalNum: finalNum
                        });
                    me.$notify.notice(data);
                    await me.getData();
                }
                catch (e) {
                    me.$notify.notice(e);
                }
            },
            async getData() {
                const me = this;
                try {
                    const data = await Api.selectChildren(me.getParams);
                    if (data.error && data.error === true) {
                        throw (data);
                    }

                    me.response = { ...data };
                }
                catch (e) {
                    me.$notify.notice(e);
                }
                finally {
                    me.loading = false;
                }
            },
            async submitData(item) {
                const me = this;
                try {
                    const apiRequestData = {
                        ...item,
                        selected: (item.workingGroupId == null) ? 1 : 0,
                        workingGroupId: me.formData.workingGroupId,
                    };
                    const data = await Api.upsertChild(apiRequestData);
                    me.$notify.notice(data);

                    if (data.error) {
                        me.formError = data;
                    } else {
                        me.$set(item, 'workingGroupId',
                            (item.workingGroupId == null) ? me.formData.workingGroupId : null);
                        me.getData();
                    }
                }
                catch (e) {
                    console.log(e);
                    me.$notify.notice(e);
                }
            },
            close() {
                const me = this;
                me.formError = {};
                me.formData = null;
                me.$emit('close');
            },
        },
        watch:
        {
            async formData(val) {
                const me = this;
                if (val != null) {
                    await me.getData();
                    me.$refs.modal.show();
                }
                else {
                    me.$refs.modal.hide();
                }
            },
            value(val) {
                const me = this;
                if (val != null) {
                    me.formData = { ...val };
                }
                else {
                    me.formData = null;
                }
            },
        },
        computed:
        {
            ...mapGetters([
                'globals',
            ]),
            getParams() {
                const me = this;
                const data = {
                    ...me.pagination,
                };
                data.status = me.childStatus;
                data.userId = me.logopedId;
                data.searchQuerry = me.searchQuerry;
                data.start = (data.currentPage - 1) * data.limit;
                data.workingGroupId = me.formData.workingGroupId;
                return data;
            },
            switchStates() {
                return this.response.root.map((item) => {

                    const isNotNull = (item.workingGroupId != null);

                    const result = {
                        id: item.childId,
                        checked: isNotNull ? true : false
                    };

                    return result;
                });
            }
        },
    };
</script>
